<script>
export default {
  name: "CertificatesStatusBlock",

  emits: ["select"],

  props: {
    status: {
      type: Object,
      required: true,
    },

    isSelected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div
    class="certificates-status-block"
    :class="{ 'certificates-status-block_selected': isSelected }"
    @click="$emit('select')"
  >
    <h6>{{ status.label }}</h6>

    <p>{{ status.count }}</p>
  </div>
</template>

<style lang="scss" scoped>
.certificates-status-block {
  border-radius: 8px;
  background-color: $light-primary;
  box-shadow: 0 0 30px 0 rgba(169, 169, 169, 0.15);
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  min-width: 100px;

  > h6 {
    @include caption-1;
    color: $dark-third;
  }

  > p {
    @include text-2-bold;
    color: $dark-primary;
  }

  &_selected {
    border: 1px solid $gold-dark;
  }
}
</style>
